import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const FaultsListContainer = lazyLoader(
  () => import("Containers/Faults/FaultsList/FaultsList")
);

export const FaultsList = () => {
  return (
    <Layout>
      <FaultsListContainer />
    </Layout>
  );
};
